import classNames from 'classnames';
import * as React from 'react';

import * as styles from './MobileLayout.css';
import { EMobileLayoutActiveSide } from '../../types/mobileSide';

interface IMobileLayoutProps {
  activeSide: EMobileLayoutActiveSide;
  leftView: React.ReactElement;
  centerView: React.ReactElement;
  rightView: React.ReactElement;
}

/**
 * Компонент верстки мобильного представления. Нужен для сохранения позиции скролла при переходе между экранами
 */
export const MobileLayout: React.FC<IMobileLayoutProps> = ({ activeSide, leftView, centerView, rightView }) => {
  return (
    <div className={styles['container']}>
      <div className={classNames(styles['view'], activeSide === EMobileLayoutActiveSide.Left && styles['visible'])}>
        {leftView}
      </div>
      <div className={classNames(styles['view'], activeSide === EMobileLayoutActiveSide.Center && styles['visible'])}>
        {centerView}
      </div>
      <div className={classNames(styles['view'], activeSide === EMobileLayoutActiveSide.Right && styles['visible'])}>
        {rightView}
      </div>
    </div>
  );
};
